import {
  ADD_SALES_ITEM_ERROR,
  ADD_SALES_ITEM_LOAD,
  ADD_SALES_ITEM_SUCCESS,
  GET_SALES_ITEMS_LOAD,
  GET_SALES_ITEMS_SUCCESS,
  GET_SALES_ITEMS_ERROR,
} from "../../actions/types";

export const addSalesReducer = (state = { items: [] }, action: any) => {
  switch (action.type) {
    case ADD_SALES_ITEM_LOAD:
      return {
        loading: true,
      };
    case ADD_SALES_ITEM_SUCCESS:
      return {
        loading: false,
        items: action.payload,
      };
    case ADD_SALES_ITEM_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const getSalesItemReducer = (state = { loaded: false }, action: any) => {
  switch (action.type) {
    case GET_SALES_ITEMS_LOAD:
      return {
        loading: true,
        loaded: false,
      };
    case GET_SALES_ITEMS_SUCCESS:
      return {
        loading: false,
        itemList: action.payload,
        loaded: true,
      };
    case GET_SALES_ITEMS_ERROR:
      return {
        loading: false,
        loaded: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
